import { getDocs, collection } from "firebase/firestore";
import { db } from "./firebase";

// ✅ Gets clips for a given subject/topic/subtopic
export async function getClipsFromFirebase(subject, topic, subtopic) {
  const querySnapshot = await getDocs(collection(db, "questions"));
  const allQuestions = querySnapshot.docs.map(doc => doc.data());

  const clipsSet = new Set();
  allQuestions.forEach(q => {
    if (
      q.subject === subject &&
      q.topic === topic &&
      q.subtopic === subtopic &&
      q.clip
    ) {
      clipsSet.add(q.clip);
    }
  });

  return Array.from(clipsSet).map(name => ({ id: name, name }));
}

// ✅ Safely convert any value to a clean string for display
function normalizeParagraphContent(item) {
  if (typeof item === "string") return item;
  if (typeof item === "object" && item !== null) {
    // If it's an image object like { url: "...jpg" }
    if (item.url && typeof item.url === "string") return item.url;
    if (item.text && typeof item.text === "string") return item.text;
    return JSON.stringify(item); // fallback if unknown object
  }
  return String(item);
}

// ✅ Fetches questions for a clip, including all metadata
export async function getFirebaseQuestions(subject, topic, subtopic, clip, version = "A") {
  const querySnapshot = await getDocs(collection(db, "questions"));
  const allQuestions = querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));

  const filtered = allQuestions.filter(q =>
    q.subject === subject &&
    q.topic === topic &&
    q.subtopic === subtopic &&
    q.clip === clip &&
    (q.version === version || !q.version) // fallback to unversioned
  );

  return filtered.map(q => {
    const rawParagraphs = q.questionParagraphs || [];
    const questionParagraphs = Array.isArray(rawParagraphs)
      ? rawParagraphs.map(normalizeParagraphContent)
      : [];

    return {
      id: q.id,
      subject: q.subject,
      topic: q.topic,
      subtopic: q.subtopic,
      clip: q.clip,
      questionText: q.questionText || "",
      questionLatex: q.questionLatex || "",
      questionHTML: q.questionHTML || "",
      questionParagraphs,
      optionalQuestionText: q.optionalQuestionText || "",
      answer: q.answer || "",
      answerPrefix: q.answerPrefix || "",
      answerSuffix: q.answerSuffix || "",
      answers: q.answers || [],
      calculator: q.calculator || "yes",
      difficulty: q.difficulty || "",
      version: q.version || "",
      textLines: [
        q.questionText || "",
        `\\(${q.questionLatex || ""}\\)`
      ]
    };
  });
}
